import {Component, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {InputSwitchComponent} from '../../../input-switch/input-switch.component';

@Component({
  selector: 'app-consent-mode-form',
  imports: [
    ReactiveFormsModule,
    InputSwitchComponent,
    FormsModule
],
  templateUrl: './consent-mode-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './consent-mode-form.component.scss'
})
export class ConsentModeFormComponent implements Dialog {

  type: 'checkbox' | 'text' = 'checkbox';

  checkbox = {
    mandatory: false,
    alreadyChecked: false,
  };

  text = {
    placement: 'up',
  };

  constructor(private dialog: DialogService) {
  }

  onDialogInit(params: DialogParams): void {
    if (params.data) {
      this.type = params.data.type;

      switch (this.type) {
        case 'checkbox':
          this.checkbox = params.data.config;
          break;
        case 'text':
          this.text = params.data.config;
          break;
        default:
          this.type = 'checkbox';
      }
    }
  }

  submit(): void {
    this.dialog.closeDialog({
      type: this.type,
      config: this.type ===  'checkbox' ? this.checkbox : this.text
    });
  }
}
